export type IDevolutionDeposit = {
  _id?: string;
  companyId: string;
  vehicleId: string;
  renterId: string;
  licensePlate: string;
  partnerCompanyName: string;
  partnerId: string,
  name: string;
  dateDevolution: Date;
  dateLocation: Date;
  dateDevolutionDeposit: Date;
  plan: string;
  file: string;
  valueDeposit: number
}

export const emptyDevolutionDeposit = () => ({
  companyId: "",
  vehicleId: "",
  renterId: "",
  licensePlate: "",
  partnerCompanyName: "",
  partnerId: "",
  name: "",
  dateDevolution: new Date(),
  dateLocation: new Date(),
  dateDevolutionDeposit: new Date(),
  plan: "",
  file: "",
  valueDeposit: 0
});